import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    inject,
    Input,
    OnInit,
    SkipSelf,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementForm } from '../../../shared-agreement.model';
import { AgreementComponent } from 'app/features/agreement/pages/agreement/agreement.component';
import { AgreementSummaryComponent } from '../../../components/summary/agreement-summary.component';
@UntilDestroy()
@Component({
    selector: 'app-agreement-summary-info',
    templateUrl: './agreement-summary-info.component.html',
    styleUrl: './agreement-summary-info.component.scss'
})
export class AgreementSummaryInfoComponent implements OnInit {
    @Input() public agreementForm: FormGroup<AgreementForm>;

    @ViewChild('editModeFooterTemplate', { static: true })
    public readonly editModeFooterTemplate: TemplateRef<ElementRef>;
    @ViewChild('summaryComp') public summaryComp: AgreementSummaryComponent;

    @SkipSelf() private readonly agreementComponent = inject(AgreementComponent);

    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    public submitting: boolean;
    public generatingPdf: boolean;
    public createPdfMode = false;

    public get fileForm() {
        return this.agreementForm.controls.fileUpload;
    }

    public get f() {
        return this.agreementForm.controls;
    }

    public get agreementCreated() {
        return this.agreementComponent.agreementCreated;
    }

    public ngOnInit() {
        this.agreementComponent.setFooterTemplate(this.editModeFooterTemplate);
    }

    public async createPdf($event: boolean) {
        console.log('Create PDF event received:', $event);
        this.createPdfMode = $event;
        this.changeDetectorRef.detectChanges();
        await Promise.resolve();
        if ($event) {
            await this.summaryComp.downloadPDF();
        }
    }

    public cancel() {
        this.agreementComponent.cancel();
    }

    public save() {
        this.agreementComponent.save();
    }
}
